module.exports = __webpack_public_path__ + "img/adver-support.ec36297c.png";